export default function getRuntimeConfig() {
  if (typeof window !== "undefined" && window.__APP_RUNTIME_CONFIG__) {
    return window.__APP_RUNTIME_CONFIG__;
  }

  return null;
}
